import VueRouter, { Route } from 'vue-router';

import { ProModal } from '@/lazy-load-components';

import { WebLocale } from '@/enums/web-locale';
import { Conversions, Currency } from '@/enums/currencies';

import { ModalHelper } from '@/helpers/modal-helper';
import { TrackingHelper } from './tracking/tracking-helper';
import IapHelper from './iap-helper';
import { getVm } from './vm-helper';

// Start COOKIE_BANNER_EXPERIMENT
import { SubscriptionInfo } from '@/interfaces/subscriptions';
function findSubscription(key: keyof SubscriptionInfo, value: string | null) {
	return Object.values(JW_CONFIG.SUBSCRIPTIONS).find(subscription => subscription[key] == value);
}
const SELECTED_SUBSCRIPTION = 'selected_subscription';

function saveSelectedSubscriptionPriceId(subscriptionPriceId: string) {
	localStorage.setItem(SELECTED_SUBSCRIPTION, subscriptionPriceId);
}

function removeSelectedSubscriptionPriceId() {
	localStorage.removeItem(SELECTED_SUBSCRIPTION);
}

function getSelectedSubscriptionPriceId() {
	return localStorage.getItem(SELECTED_SUBSCRIPTION);
}
// End

function isProWebCountry(webLocale: WebLocale) {
	const activeCountries = [
		WebLocale.us,
		WebLocale.de,
		WebLocale.at,
		WebLocale.ie,
		WebLocale.fr,
		WebLocale.es,
		WebLocale.it,
		WebLocale.pl,
		WebLocale.nl,
		WebLocale.se,
		WebLocale.fi,
		WebLocale.be,
		WebLocale.pt,
		WebLocale.cz,
		WebLocale.ro,
	];
	return activeCountries.includes(webLocale);
}

function priceConverter(priceInEuros: number, webLocale: WebLocale): number {
	return (Conversions[webLocale] || 1) * priceInEuros;
}
function priceFormatter(locale: string, webLocale: WebLocale, price: number): string {
	const formattedLocale = locale.replace(/_/g, '-');
	const priceConverted = priceConverter(price, webLocale);
	return new Intl.NumberFormat(formattedLocale, { style: 'currency', currency: Currency[webLocale] }).format(
		priceConverted
	);
}
function isPremiumUser(): boolean {
	return getVm()?.$store.getters['user/isPremium'];
}

const LAST_PRO_VIEW = 'last_pro_view';

function saveLastProView(view: string) {
	localStorage.setItem(LAST_PRO_VIEW, view);
}

function getLastProView() {
	return localStorage.getItem(LAST_PRO_VIEW);
}

function showProFeatures(webLocale: WebLocale): boolean {
	return isProWebCountry(webLocale) || isPremiumUser();
}

function handleStripeRedirect(route: Route, router: VueRouter, jwLoginId: string | undefined) {
	if (route.query['jw-pro'] === 'redirect') {
		router.push({ name: 'app.titles.popular.list' });

		ModalHelper.openModal(ProModal, {}, {}, 'StripeReturn', true);

		saveLastProView('StripeReturn');
	} else if (route.query['jw-pro'] === 'success') {
		const sessionId = route.query['session-id'];

		router.push({ name: 'app.titles.popular.list' });

		ModalHelper.openModal(ProModal, { modalType: 'loading' }, undefined, undefined, true);
		if (typeof sessionId === 'string' && jwLoginId) {
			handleStripe(sessionId, jwLoginId);
		} else {
			console.error('missing or multiple session-id query params after Stripe redirect');
		}
	}
}

async function handleStripe(sessionId: string, jwLoginId: string) {
	setTimeout(async () => {
		await IapHelper.updatePremiumStatus();
		const isPremium = getVm().$store.getters['user/isPremium'];
		if (isPremium) {
			await ModalHelper.close();
			ModalHelper.openModal(ProModal, { modalType: 'success' }, undefined, undefined, true);

			TrackingHelper.trackEvent('user_account', {
				action: 'subscription_signup',
				label: jwLoginId,
				property: getLastProView() || undefined,
			});
			setTimeout(() => {
				window.location.reload();
			}, 3000);
		} else {
			await ModalHelper.close();
			ModalHelper.openModal(ProModal, { modalType: 'error' }, undefined, undefined, true);

			TrackingHelper.trackEvent('user_account', {
				action: 'subscription_signup_error',
				label: jwLoginId,
				property: getLastProView() || undefined,
			});
		}
	}, 3000);
}

export {
	isProWebCountry,
	handleStripeRedirect,
	saveLastProView,
	getLastProView,
	showProFeatures,
	priceConverter,
	priceFormatter,
	findSubscription,
	getSelectedSubscriptionPriceId,
	saveSelectedSubscriptionPriceId,
	removeSelectedSubscriptionPriceId,
};
